import { Component } from "@angular/core";
/**
 * The dialog will close with true if user clicks the ok button,
 * otherwise it will close with undefined.
 */

@Component({
    selector: "app-logout-confirmation-dialog",
    templateUrl: "./logout-confirmation-dialog.component.html",
    styleUrls: ["./logout-confirmation-dialog.component.scss"],
})
export class LogoutConfirmationDialogComponent {}
